
import { CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SearchBar } from "../subscriptions/SearchBar";
import { StatusFilter } from "./StatusFilter";

interface BillsPageHeaderProps {
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  statusFilter: string | null;
  onStatusFilterChange: (status: string | null) => void;
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export function BillsPageHeader({
  pageSize,
  onPageSizeChange,
  statusFilter,
  onStatusFilterChange,
  searchTerm,
  onSearchChange,
}: BillsPageHeaderProps) {
  return (
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
      <CardTitle>Bills</CardTitle>
      <div className="flex gap-4">
        <Select
          value={pageSize.toString()}
          onValueChange={(value) => onPageSizeChange(Number(value))}
        >
          <SelectTrigger className="w-[100px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((size) => (
              <SelectItem key={size} value={size.toString()}>
                {size} rows
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <StatusFilter value={statusFilter} onChange={onStatusFilterChange} />
        <SearchBar value={searchTerm} onChange={onSearchChange} />
      </div>
    </CardHeader>
  );
}
